import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const skillApiGet = createApi({
  reducerPath: 'skillApiGet',
  baseQuery: rtkBaseQuery('/staff'),
  endpoints: (builder) => ({
    getAllSkill: builder.query({
      query: () => ({
        url: '/Staff/GetSkillList',
        method: 'GET',
      }),
    }),
    getAllCompanies: builder.query({
      query: () => ({
        url: '/Company/GetAll',
        method: 'GET',
      }),
    }),
    getAllOrgStructureById: builder.query({
      query: ({ companyId }) => ({
        url: '/Division/GetHierarchyByCompanyId',
        method: 'GET',
        params: { companyId },
      }),
    }),
    getOrgStructure: builder.query({
      query: () => ({
        url: '/Division/getOrgStructure',
        method: 'GET',
      }),
    }),
    getDivisionById: builder.query({
      query: ({ id }) => ({
        url: '/Division/GetById',
        method: 'GET',
        params: { id },
      }),
    }),
    getHierarchy: builder.query({
      query: () => '/Division/GetHierarchy',
    }),
    createDivision: builder.mutation({
      query: (body) => ({
        url: '/Division/Create',
        method: 'POST',
        body,
      }),
    }),
    deleteDivision: builder.mutation({
      query: ({ id }) => ({
        url: '/Division/Delete',
        method: 'DELETE',
        params: { id },
      }),
    }),
    editDivision: builder.mutation({
      query: ({ id, body }) => ({
        url: '/Division/Update',
        method: 'PUT',
        params: { id },
        body,
      }),
    }),
    GetCurrentBirthdaySettings: builder.query({
      query: () => ({
        url: '/Staff/GetCurrentBirthdaySettings',
        method: 'GET',
      }),
    }),
    BirthdaySettings: builder.mutation({
      query: (params) => ({
        url: '/Staff/BirthdaySettings',
        method: 'POST',
        params,
      }),
    }),
  }),
});

export const {
  useGetAllSkillQuery,
  useGetAllCompaniesQuery,
  useGetAllOrgStructureByIdQuery,
  useGetOrgStructureQuery,
  useGetDivisionByIdQuery,
  useGetHierarchyQuery,
  useCreateDivisionMutation,
  useDeleteDivisionMutation,
  useEditDivisionMutation,
  useGetCurrentBirthdaySettingsQuery,
  useBirthdaySettingsMutation,
} = skillApiGet;
